import { Box } from '@mui/material';
import React from 'react';
import DELETE_ICON from '../../../../assets/svg/delete-icon.svg';
import Input from '../../../../components/Input/Input';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { CustomFieldErrors, FormValuesFood, ICustomizeGroupSettings } from '../../menu.types';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { LANG_TEXT } from '../../../../constants/language';

function CustomizeGroupSettings({
  index,
  control,
  setCustomizeGroupSettings,
  errors,
  setValue,
}: {
  index: number;
  control: Control<FormValuesFood>;
  setCustomizeGroupSettings: React.Dispatch<React.SetStateAction<ICustomizeGroupSettings[]>>;
  errors: FieldErrors<FormValuesFood>;
  setValue: UseFormSetValue<FormValuesFood>;
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleRemoveSetting = () => {
    setCustomizeGroupSettings((prevSettings) => {
      const updatedSettings = prevSettings.filter((_, i) => i !== index);
      setValue(`customize_group_settings`, updatedSettings);
      return updatedSettings;
    });
  };

  return (
    <Box key={index} className={classes.CustomizeGroupSettings}>
      <Input
        error={(errors as CustomFieldErrors)?.customize_group_settings?.[index]?.name?.message || ''}
        control={control}
        name={`customize_group_settings[${index}].name`}
        placeholder={t(LANG_TEXT.OPTION_NAME)}
        type="text"
      />
      <Input
        error={(errors as CustomFieldErrors)?.customize_group_settings?.[index]?.price?.message || ''}
        control={control}
        name={`customize_group_settings[${index}].price`}
        placeholder={t(LANG_TEXT.PRICE)}
        type="number"
        startAdornment={true}
      />
      <Box className={classes.DeleteButton}>
        <img src={DELETE_ICON} height={24} width={24} alt="DELETE_ICON" onClick={handleRemoveSetting} />
      </Box>
    </Box>
  );
}

export default CustomizeGroupSettings;
